import { showAlert } from '@silverfort/sf-components';
import { User } from '../../../types/User';
import { useUpdateTokens } from '../../../api/mutations/useUpdateToken';
import { useUsersActionPopup } from './useUserActionPopup';

interface UseDeleteUsersTokensPopupParams {
    users: User[];
    onTokensDeleted?: () => void;
}

interface UseDeleteUsersTokensPopupReturnType {
    openDeleteUsersTokensPopup: () => void;
}

export const useDeleteUsersTokensPopup = ({
    users,
    onTokensDeleted
}: UseDeleteUsersTokensPopupParams): UseDeleteUsersTokensPopupReturnType => {
    const handleSuccess = () => {
        closePopup();
        onTokensDeleted?.();
        showAlert('Tokens deleted successfully', 'success');
    };

    const handleError = () => {
        closePopup();
        showAlert('Failed to delete tokens', 'error');
    };

    const { updateTokens } = useUpdateTokens({
        onSuccess: handleSuccess,
        onError: handleError
    });

    const handleDelete = () => {
        const tokensDetails = users.flatMap((user) =>
            user.tokens.map((token) => ({
                id: token.id,
                userId: token.userId
            }))
        );
        updateTokens(tokensDetails.map(({ id, userId }) => ({ id, userId, isDeleted: true })));
    };

    const { openUsersActionPopup, closePopup } = useUsersActionPopup({
        actionLabel: 'Delete',
        text: 'Are you sure you want to delete all tokens?',
        users,
        onAction: handleDelete,
        title: 'Delete all tokens'
    });

    return {
        openDeleteUsersTokensPopup: openUsersActionPopup
    };
};
